import { readJson } from './errors';

const API = process.env.REACT_APP_BACKEND_URL;

// Institute-admin call to /api/*. Throws on any non-2xx (readJson), so every
// caller must catch — a swallowed rejection is a save that silently failed.
export const institutionApi = async (path, opts = {}) => {
  const token = localStorage.getItem('desky_token');
  const json = !(opts.body instanceof FormData);
  const res = await fetch(`${API}/api${path}`, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, ...(json ? { 'Content-Type': 'application/json' } : {}), ...opts.headers },
  });
  return readJson(res);
};
